import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typeahead from '../Typeahead';
import StabTypeaheadIcon from '../StabTypeaheadIcon';
import DatePicker from '../DatePicker';
import DatePickerIcon from '../DatePickerIcon';
import StabDatePickerIcon from '../StabDatePickerIcon';
import GuestPicker from '../GuestPicker';
import GuestPickerIcon from '../GuestPickerIcon';
import StabGuestPickerIcon from '../StabGuestPickerIcon';
import {SearchButton} from '../SearchButton';
import './style.less';

class SearchForm extends React.Component {
    static propTypes = {
        maxNumGuests: PropTypes.number,
        query: PropTypes.string,
        onInputQuery: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        guests: PropTypes.shape({
            adultsCount: PropTypes.number,
            childrenCount: PropTypes.number,
            petIncluded: PropTypes.bool
        }).isRequired,
        onInputGuest: PropTypes.func.isRequired,
        onInputGuestClose: PropTypes.func.isRequired,
        onInputGuestExit: PropTypes.func,
        checkIn: PropTypes.string,
        onInputCheckIn: PropTypes.func.isRequired,
        checkOut: PropTypes.string,
        onInputCheckOut: PropTypes.func.isRequired,
        labels: PropTypes.shape({}),
        locale: PropTypes.string,
        typeaheadProps: PropTypes.shape({}),
        isLoadingSerp: PropTypes.bool,
        isTypeaheadInputFocus: PropTypes.bool,
        onBlur: PropTypes.func,
        onSelectDestination: PropTypes.func.isRequired,
        consolidateInputs: PropTypes.bool,
        smartDatePicker: PropTypes.bool,
        typeaheadIcon: PropTypes.bool,
        datePickerIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func, PropTypes.bool]),
        guestPickerIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func, PropTypes.bool]),
        hideClearDatesBtn: PropTypes.bool,
        stabTheme: PropTypes.bool,
        calendarLabels: PropTypes.shape({}),
        animatedCue: PropTypes.bool,
        displayYearFirst: PropTypes.bool
    };

    static defaultProps = {
        isMobile: false,
        query: 'Where do you want to go?'
    };

    render() {
        const {
            checkIn,
            checkOut,
            guests,
            query,
            isMobile,
            labels,
            locale,
            typeaheadProps,
            isLoadingSerp,
            isGuestPickerOpened,
            isDatePickerOpened,
            isTypeaheadInputFocus,
            onBlur,
            onClose,
            onSelectDestination,
            consolidateInputs,
            smartDatePicker,
            typeaheadIcon,
            datePickerIcon,
            guestPickerIcon,
            hideClearDatesBtn,
            stabTheme,
            onInputGuestExit,
            showStabIcons,
            calendarLabels,
            animatedCue,
            displayYearFirst
        } = this.props;

        const searchFormClass = classNames('SearchForm', {
            'checkin-focus': !checkIn || checkIn && checkOut,
            'checkout-focus': checkIn && !checkOut,
            'has-checkin': checkIn,
            'has-checkout': checkOut,
            'has-guests': guests.adultsCount + guests.childrenCount > 0
        });

        const datePickerLocale = locale === 'no_NO_HA' ? locale.replace(/^no/, 'nb') : locale;

        const CustomDatePickerIcon = showStabIcons ? StabDatePickerIcon : DatePickerIcon;
        const CustomGuestPickerIcon = showStabIcons ? StabGuestPickerIcon : GuestPickerIcon;

        return (
            <form className={searchFormClass} onSubmit={this.props.onSubmit}>
                <Typeahead
                    onInputQuery={this.props.onInputQuery}
                    labels={labels.typeahead}
                    {...(typeaheadIcon && showStabIcons && {inputIcon: <StabTypeaheadIcon />})}
                    {...(!typeaheadIcon && {inputIcon: false})}
                    {...{query, locale, onBlur, typeaheadProps, isTypeaheadInputFocus,
                        onSelectDestination, consolidateInputs}}
                />
                <DatePicker
                    onInputCheckOut={this.props.onInputCheckOut}
                    onInputCheckIn={this.props.onInputCheckIn}
                    labels={labels.datePicker}
                    isOpen={isDatePickerOpened}
                    inputIcon={datePickerIcon === true ? <CustomDatePickerIcon /> : null}
                    {...{isMobile, checkIn, checkOut, locale: datePickerLocale, calendarLabels,
                        onClose, consolidateInputs, smartDatePicker, hideClearDatesBtn,
                        stabTheme, animatedCue, displayYearFirst}}
                />
                <GuestPicker
                    onInputGuest={this.props.onInputGuest}
                    onInputGuestClose={this.props.onInputGuestClose}
                    labels={labels.guests}
                    isOpen={isGuestPickerOpened}
                    inputIcon={guestPickerIcon === true ? <CustomGuestPickerIcon /> : null}
                    {...{isMobile, guests, consolidateInputs, onInputGuestExit}}
                />
                <SearchButton className="SearchForm__button" label={labels.buttonTitle} isLoadingSerp={isLoadingSerp} />
            </form>
        );
    }
}

export default SearchForm;
